/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Parameters
 */
export interface Parameters {
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    analytics?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    brandingCss?: string;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    brandingLogo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    clientOfferFileSearch?: boolean;
    /**
     * http://host/
     * @type {string}
     * @memberof Parameters
     */
    externalUrl?: string | null;
    /**
     * Recycle bins are usually either in Workspace/Share or Volume folder
     * @type {boolean}
     * @memberof Parameters
     */
    fileManagerRecycleBin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    httpsRedirect?: ParametersHttpsRedirectEnum;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    language?: ParametersLanguageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    ltfsDefaultRestoreToOriginalLocation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    ltfsDefaultSearchDirectories?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    ltfsLibraryAddress?: string | null;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof Parameters
     */
    mailStyling?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    mediaAllowAnonymousLinks?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    mediaAutoPlay?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    mediaAutoProxy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    mediaAutoScan?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    mediaAutoTransport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    mediaBackgroundAutoPause?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    mediaDefaultCustomFieldType?: ParametersMediaDefaultCustomFieldTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    mediaDefaultDeleteBehaviour?: ParametersMediaDefaultDeleteBehaviourEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    mediaForceShowDeleted?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    mediaKeepSelectionWhenBrowsing?: boolean;
    /**
     * Recycle bin is usually in the .recycle-bin folder in the volume root
     * @type {boolean}
     * @memberof Parameters
     */
    mediaRecycleBin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    mediaRequireLinkPassword?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Parameters
     */
    mediaMaxLinkViews?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    mediaShuttleLeftBehaviour?: ParametersMediaShuttleLeftBehaviourEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    ntpOfferSync?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    otpPolicy?: ParametersOtpPolicyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    sessionKeyRestrictToIp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    tasksRunScheduled?: boolean;
    /**
     * Copy this value from an existing user
     * @type {string}
     * @memberof Parameters
     */
    usersDefaultPermissions?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Parameters
     */
    userNotificationSettings?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    workspacesFolderTemplatePath?: string;
    /**
     * 
     * @type {string}
     * @memberof Parameters
     */
    workspacesPath?: string;
}

/**
* @export
* @enum {string}
*/
export enum ParametersHttpsRedirectEnum {
    Domain = 'domain',
    On = 'on'
}/**
* @export
* @enum {string}
*/
export enum ParametersLanguageEnum {
    En = 'en',
    Fr = 'fr',
    De = 'de',
    Ru = 'ru'
}/**
* @export
* @enum {string}
*/
export enum ParametersMediaDefaultCustomFieldTypeEnum {
    File = 'file',
    Asset = 'asset'
}/**
* @export
* @enum {string}
*/
export enum ParametersMediaDefaultDeleteBehaviourEnum {
    Disk = 'disk',
    Database = 'database',
    Completely = 'completely'
}/**
* @export
* @enum {string}
*/
export enum ParametersMediaShuttleLeftBehaviourEnum {
    Slowdown = 'slowdown',
    Stop = 'stop'
}/**
* @export
* @enum {string}
*/
export enum ParametersOtpPolicyEnum {
    AdminOnly = 'admin-only',
    SelfServiceSetupOnly = 'self-service-setup-only',
    SelfServiceAll = 'self-service-all'
}

export function ParametersFromJSON(json: any): Parameters {
    return ParametersFromJSONTyped(json, false);
}

export function ParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): Parameters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'analytics': !exists(json, 'analytics') ? undefined : json['analytics'],
        'brandingCss': !exists(json, 'branding_css') ? undefined : json['branding_css'],
        'brandingLogo': !exists(json, 'branding_logo') ? undefined : json['branding_logo'],
        'clientOfferFileSearch': !exists(json, 'client_offer_file_search') ? undefined : json['client_offer_file_search'],
        'externalUrl': !exists(json, 'external_url') ? undefined : json['external_url'],
        'fileManagerRecycleBin': !exists(json, 'file_manager_recycle_bin') ? undefined : json['file_manager_recycle_bin'],
        'httpsRedirect': !exists(json, 'https_redirect') ? undefined : json['https_redirect'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'ltfsDefaultRestoreToOriginalLocation': !exists(json, 'ltfs_default_restore_to_original_location') ? undefined : json['ltfs_default_restore_to_original_location'],
        'ltfsDefaultSearchDirectories': !exists(json, 'ltfs_default_search_directories') ? undefined : json['ltfs_default_search_directories'],
        'ltfsLibraryAddress': !exists(json, 'ltfs_library_address') ? undefined : json['ltfs_library_address'],
        'mailStyling': !exists(json, 'mail_styling') ? undefined : json['mail_styling'],
        'mediaAllowAnonymousLinks': !exists(json, 'media_allow_anonymous_links') ? undefined : json['media_allow_anonymous_links'],
        'mediaAutoPlay': !exists(json, 'media_auto_play') ? undefined : json['media_auto_play'],
        'mediaAutoProxy': !exists(json, 'media_auto_proxy') ? undefined : json['media_auto_proxy'],
        'mediaAutoScan': !exists(json, 'media_auto_scan') ? undefined : json['media_auto_scan'],
        'mediaAutoTransport': !exists(json, 'media_auto_transport') ? undefined : json['media_auto_transport'],
        'mediaBackgroundAutoPause': !exists(json, 'media_background_auto_pause') ? undefined : json['media_background_auto_pause'],
        'mediaDefaultCustomFieldType': !exists(json, 'media_default_custom_field_type') ? undefined : json['media_default_custom_field_type'],
        'mediaDefaultDeleteBehaviour': !exists(json, 'media_default_delete_behaviour') ? undefined : json['media_default_delete_behaviour'],
        'mediaForceShowDeleted': !exists(json, 'media_force_show_deleted') ? undefined : json['media_force_show_deleted'],
        'mediaKeepSelectionWhenBrowsing': !exists(json, 'media_keep_selection_when_browsing') ? undefined : json['media_keep_selection_when_browsing'],
        'mediaRecycleBin': !exists(json, 'media_recycle_bin') ? undefined : json['media_recycle_bin'],
        'mediaRequireLinkPassword': !exists(json, 'media_require_link_password') ? undefined : json['media_require_link_password'],
        'mediaMaxLinkViews': !exists(json, 'media_max_link_views') ? undefined : json['media_max_link_views'],
        'mediaShuttleLeftBehaviour': !exists(json, 'media_shuttle_left_behaviour') ? undefined : json['media_shuttle_left_behaviour'],
        'ntpOfferSync': !exists(json, 'ntp_offer_sync') ? undefined : json['ntp_offer_sync'],
        'otpPolicy': !exists(json, 'otp_policy') ? undefined : json['otp_policy'],
        'sessionKeyRestrictToIp': !exists(json, 'session_key_restrict_to_ip') ? undefined : json['session_key_restrict_to_ip'],
        'tasksRunScheduled': !exists(json, 'tasks_run_scheduled') ? undefined : json['tasks_run_scheduled'],
        'usersDefaultPermissions': !exists(json, 'users_default_permissions') ? undefined : json['users_default_permissions'],
        'userNotificationSettings': !exists(json, 'user_notification_settings') ? undefined : json['user_notification_settings'],
        'workspacesFolderTemplatePath': !exists(json, 'workspaces_folder_template_path') ? undefined : json['workspaces_folder_template_path'],
        'workspacesPath': !exists(json, 'workspaces_path') ? undefined : json['workspaces_path'],
    };
}

export function ParametersToJSON(value?: Parameters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'analytics': value.analytics,
        'branding_css': value.brandingCss,
        'branding_logo': value.brandingLogo,
        'client_offer_file_search': value.clientOfferFileSearch,
        'external_url': value.externalUrl,
        'file_manager_recycle_bin': value.fileManagerRecycleBin,
        'https_redirect': value.httpsRedirect,
        'language': value.language,
        'ltfs_default_restore_to_original_location': value.ltfsDefaultRestoreToOriginalLocation,
        'ltfs_default_search_directories': value.ltfsDefaultSearchDirectories,
        'ltfs_library_address': value.ltfsLibraryAddress,
        'mail_styling': value.mailStyling,
        'media_allow_anonymous_links': value.mediaAllowAnonymousLinks,
        'media_auto_play': value.mediaAutoPlay,
        'media_auto_proxy': value.mediaAutoProxy,
        'media_auto_scan': value.mediaAutoScan,
        'media_auto_transport': value.mediaAutoTransport,
        'media_background_auto_pause': value.mediaBackgroundAutoPause,
        'media_default_custom_field_type': value.mediaDefaultCustomFieldType,
        'media_default_delete_behaviour': value.mediaDefaultDeleteBehaviour,
        'media_force_show_deleted': value.mediaForceShowDeleted,
        'media_keep_selection_when_browsing': value.mediaKeepSelectionWhenBrowsing,
        'media_recycle_bin': value.mediaRecycleBin,
        'media_require_link_password': value.mediaRequireLinkPassword,
        'media_max_link_views': value.mediaMaxLinkViews,
        'media_shuttle_left_behaviour': value.mediaShuttleLeftBehaviour,
        'ntp_offer_sync': value.ntpOfferSync,
        'otp_policy': value.otpPolicy,
        'session_key_restrict_to_ip': value.sessionKeyRestrictToIp,
        'tasks_run_scheduled': value.tasksRunScheduled,
        'users_default_permissions': value.usersDefaultPermissions,
        'user_notification_settings': value.userNotificationSettings,
        'workspaces_folder_template_path': value.workspacesFolderTemplatePath,
        'workspaces_path': value.workspacesPath,
    };
}


